import $ from 'jquery';
import CreateVisiteMedicale from '@/views/mdt/visite-medicales/categories/visites-medicales-annuelles/create-visite-modal'

export default {
    name: 'visites-medicales-annuelles',
    components: { CreateVisiteMedicale },
    props: [],
    data() {
        return {
            selected_societe: "",
            date: "",
            filter: "",
            items: [
                { 
                    id: 1, annee: "2021", debut: "23 juin 2021", fin: "18 juillet 2021", 
                    societe: "IKEA SA", voir: "" 
                },
            ],
            fields: [
                { key: 'index', label: 'N°' },
                { key: 'annee', label: 'Année' },
                { key: 'date_debut', label: 'Debut' },
                { key: 'date_fin', label: 'Fin' },
                { key: 'societe', label: 'Societe' },
                'voir'
            ],

            is_loading: true,
            is_empty: false
        }
    },
    watch: {
        date() {
            this.searchVisites()
        },

        selected_societe() {
            this.searchVisites()
        }
    },
    computed: {
        societes() {
            return this.$store.getters["societes"];
        },

        visites() {
            return this.$store.getters["visitesMedicales"]
        },

        subCategorieVM() {
            return this.$store.getters["selectedSousCategoryVM"]
        }
    },

    mounted() {
        let the_role = $("tr:eq(2)").hide()
        console.log(the_role)

        this.$store.dispatch('getVisitesMedicales', this.$route.params.id).then(() => {
            console.log("--> ", this.visites)
            if (this.visites.length > 0) {
                this.is_empty = false
            } else {
                this.is_empty = true
            }
            this.is_loading = false
        })
    },

    updated() {
        let the_role = $("tr:eq(2)").hide()
        console.log(the_role)
    },

    methods: {
        searchVisites: function () {
            let societe_id = null

            if (this.selected_societe === null) {
                societe_id = ""
            } else {
                societe_id = this.selected_societe.id
            }

            let sous_categorie_id = this.subCategorieVM

            this.$store.dispatch("searchVisitesMedicales", {
                sous_categorie_id: sous_categorie_id.id,
                societe_id: societe_id,
                date: this.date
            })
        }
    }
}


